import app from './app'

import { PASSIVE } from './base/utils/passive-support'

declare global {
    interface Window {
        SUNEDITOR: any;
    }
}


document.body.appendChild(app.el)
document.addEventListener('touchstart', () => false, PASSIVE)
